<script lang="ts" setup>
import VerificationSubmittedIllustration from '@Assets/images/verification-submitted.svg';

withDefaults(defineProps<{
    showTitle?: boolean;
    showIllustration?: boolean;
    // PS-1169: suppressed in portal context, where the participant is offered a route back
    // to the dashboard and telling them to close the tab contradicts it.
    showCloseNotice?: boolean;
}>(), {
    showTitle: true,
    showIllustration: true,
    showCloseNotice: true,
});
</script>

<template>
    <div class="verification-submitted">
        <img
            v-if="showIllustration"
            :src="VerificationSubmittedIllustration"
            alt="Verification Submitted"
            class="verification-submitted__illustration">

        <div class="verification-submitted__header">
            <h1
                v-if="showTitle"
                class="verification-submitted__headline">
                Verification submitted
            </h1>

            <p class="verification-submitted__description">
                Thank you for submitting your ID and photo! We have notified your closing
                representative that you have completed the verification process.
            </p>
        </div>

        <p
            v-if="showCloseNotice"
            class="verification-submitted__close-notice">
            You may now close this tab.
        </p>
    </div>
</template>

<style lang="scss" scoped>
@use 'certifid-v2-client-hub-styles' as *;

.verification-submitted {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1.5rem;
    text-align: left;
    width: 100%;

    &__illustration {
        width: 6rem;
        height: auto;
        display: block;
        align-self: center;
    }

    &__header {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }

    &__headline {
        font-size: 1.625rem;
        font-weight: 700;
        line-height: 1.5;
        color: var(--ch-primary-dark);
    }

    &__description {
        font-size: 1rem;
        line-height: 1.5;
        color: $black-high;
    }

    &__close-notice {
        font-size: 1rem;
        line-height: 1.5;
        color: $black-high;
    }
}

@include tablet-and-down {
    .verification-submitted {
        &__headline {
            font-size: 1.5rem;
        }

        &__description,
        &__close-notice {
            font-size: 0.9375rem;
        }
    }
}
</style>
